import { render, staticRenderFns } from "./ContactWallet.vue?vue&type=template&id=5d8df2fc&"
import script from "./ContactWallet.vue?vue&type=script&lang=js&"
export * from "./ContactWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports